module.exports = __webpack_public_path__ + "static/media/EE_3.aec0e70f.PNG";